import React, { useState, useEffect } from 'react';
import { FormGroup } from 'src/components/ui';
import InputMask from 'react-input-mask';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import useTestId from '../../hooks/useTestId';
import { useAutofillSafeName } from '../../hooks/useAutofillSafeName';
import { PK_CFIID_MASK, PK_CFIID_EXAMPLE } from '../../util/pkCfiid';

/** Masked input for an institution's PK_CFIID (three letters then five digits, e.g. DBD00001).
 *
 * Letters are uppercased as they are typed: the backend's validator is case-SENSITIVE ([A-Z]{3}),
 * so a lowercase entry would otherwise read as valid to the user and come back as a 400.
 */
export default function PkCfiidInput({ id, value, required, disabled, readonly, autofocus, placeholder, onChange: onChangeForm }) {
  const [current, setCurrent] = useState(value || '');
  const testIdProps = useTestId(id);
  const autofillSafeName = useAutofillSafeName();

  useDebouncedEffect(
    () => {
      if (current !== value) {
        onChangeForm(current);
      }
    },
    [current],
    450
  );

  useEffect(() => setCurrent(value || ''), [value]);

  return (
    <FormGroup>
      <InputMask
        mask={PK_CFIID_MASK}
        // No filler character: a half-typed ID stays "FSJ0" rather than becoming "FSJ0____", which
        // would be submitted verbatim and rejected.
        maskChar={null}
        disabled={disabled}
        name={autofillSafeName}
        autoComplete="off"
        className="form-control"
        value={current}
        required={required}
        onChange={e => setCurrent(e.target.value.toUpperCase())}
        readOnly={readonly}
        autoFocus={autofocus}
        id={id}
        placeholder={placeholder || PK_CFIID_EXAMPLE}
        {...testIdProps}
      />
    </FormGroup>
  );
}
